import { environment } from '../../environments/environment';

export const BE_API_URL = environment.apiUrl;
export const BE_API_AUTH_URL = environment.apiAuthUrl;
export const DOMAIN = environment.domain;

const globalWindow: any = typeof window !== 'undefined' ? window : {};
export const WEB_PUSH_PUBLIC_KEY = globalWindow.__env?.WEB_PUSH_PUBLIC_KEY || '';
export const LANDING_PAGE_START_URL_STORAGE_KEY = 'scanafy:lastLandingPageStartUrl';
export const LANDING_PAGE_CONTEXT_STORAGE_KEY = 'scanafy:lastLandingPageContext';
export const LANDING_PAGE_START_URL_COOKIE_KEY = 'scanafy_lastLandingPageStartUrl';
export const LANDING_PAGE_CONTEXT_COOKIE_KEY = 'scanafy_lastLandingPageContext';
export const TRANSLATION_ENABLED = !DOMAIN.includes('localhost');